var PageId = /* @__PURE__ */ ((PageId2) => {
  PageId2["Home"] = "Home";
  PageId2["PLP"] = "PLP";
  PageId2["Search"] = "Search";
  PageId2["Category"] = "Category";
  PageId2["PDC"] = "PDC";
  PageId2["PDP"] = "PDP";
  PageId2["LATPDP"] = "LATPDP";
  PageId2["CorePDP"] = "CorePdp";
  PageId2["Gallery"] = "Gallery";
  PageId2["Recommendation"] = "Recommendation";
  PageId2["LaunchMyBusiness"] = "LaunchMyBusiness";
  PageId2["Favorites"] = "Favorites";
  PageId2["FavoritesTemplateSection"] = "FavoritesTemplateSection";
  PageId2["UnknownPage"] = "";
  return PageId2;
})(PageId || {});
const fullWidthInclusivePages = [
  "PDC" /* PDC */
];
const pagesWithNoQtyCheck = [
  "PDP" /* PDP */,
  "LATPDP" /* LATPDP */
];

export { PageId, fullWidthInclusivePages, pagesWithNoQtyCheck };
//# sourceMappingURL=src-constants-pageId.js.map
